module.exports = __webpack_public_path__ + "img/cover_logo.7e7d59e5.png";